// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"155":"d1cf2076","626":"d68f5a71"}[chunkId] + ".chunk.css";
};